import { Edit } from 'react-admin';
import { UserForm } from './User.Form';

export const UserEdit = () => {
    return (
        <Edit>
            <UserForm />
        </Edit>
    );
};
